import { useRefsContext } from "@/contexts/ref";
import { smartScrollToRef } from "@/utils/customSmoothScroll";
import { useCallback } from "react";
import { useCustomerAction } from "./tracking";
export const useScrollTo = (interaction) => {
    const { propertyProviderRef } = useRefsContext();
    const { customerActionExposeInteraction } = useCustomerAction();
    const handleScrollClick = useCallback(() => {
        if (propertyProviderRef === null || propertyProviderRef === void 0 ? void 0 : propertyProviderRef.current) {
            smartScrollToRef(propertyProviderRef, 400, -100, () => {
                customerActionExposeInteraction([
                    {
                        key: "interaction",
                        value: interaction,
                    },
                ]);
            });
        }
    }, [customerActionExposeInteraction, propertyProviderRef, interaction]);
    return handleScrollClick;
};
